import type { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <h1 className="header-title">Asset Manager</h1>
          <p className="header-subtitle">Upload and link hosted assets to Webflow items</p>
        </div>
      </header>
      <main className="main">
        <div className="container">{children}</div>
      </main>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} DemandMetric</p>
      </footer>
    </div>
  );
}
